import { Component, ViewEncapsulation, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { TIME_TO_SLIDE, ANIMATIONS } from '@app/constants/animations.constants';
import { AppFacade } from '@app/app.facade';
import { IS_MOBILE } from '@app/modules/core/tokens/app.tokens';

@Component({
  selector: 'app-right-repentance',
  templateUrl: './right-repentance.component.html',
  styleUrls: ['./right-repentance.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RightRepentanceComponent {

  public animation: string = ANIMATIONS.SLIDE_IN_RIGHT;
  public readonly booking: string = 'booking';

  constructor(
    private facade: AppFacade,
    @Inject(IS_MOBILE) public isMobile: boolean,
    private router: Router,
  ) { }

  public goBack(): void {
    this.animation = ANIMATIONS.SLIDE_OUT_RIGHT;
    this.facade.historyPop();
    setTimeout(() => this.facade.navigateToLastRoute(), TIME_TO_SLIDE);
  }

  get isBookingRoute(): boolean {
    return this.router.url.includes(this.booking);
  }


}
